import { ListItemIcon,Menu, MenuItem } from '@mui/material';
import React from 'react'

const MonumentMenu = ({anchor,open,onClose,pageConfig,setHideDrawer,tools}) => {
  return (

    <Menu 
    id='monument-tools'
    anchorEl={anchor}
     open={open}
    onClose={onClose}
    anchorOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    MenuListProps={{
      'aria-labelledby': 'basic-button',
    }}
    PaperProps={{
      style: {
        backgroundColor: '#0e6347',
        color: '#fff',
        fontFamily: 'poppins',
      }
      
    }}                     
>
  <MenuItem 
    onClick={(e) => {
      setHideDrawer(true);
      tools('monumentProject');
    }}
    sx={{
      '&:hover': {
        backgroundColor: '#0a3d2c',
      },
    }} 
  >
    <ListItemIcon>
       {/* <BookmarkIcon style={{ color: "#fff" }}/> */}
    </ListItemIcon>Monument Projects
  </MenuItem>

</Menu>
  )
}

export default MonumentMenu